import React from "react";

export const VerticalSpace: React.FC<{ size: number }> = ({ size }) => (
  <div style={{ height: `${size}px`, width: "100%" }}></div>
);
